import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';

// Buildout Blue
export const DELIVERED_COLOR = '#154A93';

// Electric 2.0
export const OPENED_COLOR = '#22C3EA';

// Jelly
export const CLICKED_COLOR = '#8A1BD9';

const LIGHT_GRAY = '#F8F8FA';

export default class EmailDonut extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    emailsClicked: PropTypes.number,
    emailsDelivered: PropTypes.number,
    emailsOpened: PropTypes.number,
    type: PropTypes.oneOf(['deliveries', 'opens', 'clicks'])
  };

  static defaultProps = {
    className: ''
  }

  static paddingCount = 0;

  addPaddingRing = () => {
    const padding = {
      backgroundColor: LIGHT_GRAY,
      borderWidth: 0,
      data: [1],
      label: `padding-${this.paddingCount}`
    };
    this.paddingCount++;
    return padding;
  }

  overview = () => !this.props.type;

  data = () => {
    const { emailsClicked, emailsDelivered, emailsOpened, type } = this.props;

    const percentOfTotal = num => `${Math.round((num / emailsDelivered) * 100)}%`;

    switch (type) {
    case 'opens':
      return {
        num: percentOfTotal(emailsOpened),
        label: 'Total Opens',
        subtitle: `${emailsOpened} Unique Opens`
      };
    case 'clicks':
      return {
        num: percentOfTotal(emailsClicked),
        label: 'Total Clicks',
        subtitle: `${emailsClicked} Unique Clicks`
      };
    default:
      return {
        num: emailsDelivered,
        label: 'Total Emails Sent',
        subtitle: ''
      };
    }
  }

  chartColors = (type = this.props.type) => {
    switch (type) {
    case 'opens':
      return [OPENED_COLOR, LIGHT_GRAY, LIGHT_GRAY];
    case 'clicks':
      return [CLICKED_COLOR, LIGHT_GRAY, LIGHT_GRAY];
    case 'deliveries':
      return [DELIVERED_COLOR, DELIVERED_COLOR, DELIVERED_COLOR];
    default:
      return [CLICKED_COLOR, OPENED_COLOR, DELIVERED_COLOR];
    }
  }

  chartData = (type = this.props.type) => {
    const { emailsClicked, emailsDelivered, emailsOpened } = this.props;
    const onlyOpened = emailsOpened - emailsClicked;
    const ignored = emailsDelivered - emailsOpened;

    switch (type) {
    case 'opens':
      return [emailsOpened, emailsClicked, ignored];
    case 'clicks':
      return [emailsClicked, ignored, onlyOpened];
    default:
      return [1];
    }
  }

  chartOptions = () => {
    const options = {
      height: null,
      width: null,
      options: {
        aspectRatio: 1,
        cutoutPercentage: this.overview() ? 65 : 80,
        hover: { mode: null },
        tooltips: { enabled: false }
      }
    };

    return options;
  }

  renderOverviewDonuts() {
    return (
      <Doughnut
        data={{
          datasets: [this.addPaddingRing(), this.addPaddingRing(), {
            backgroundColor: this.chartColors('deliveries'),
            borderWidth: 0,
            data: this.chartData('deliveries'),
            label: 'deliveries'
          }, {
            backgroundColor: this.chartColors('opens'),
            borderColor: LIGHT_GRAY,
            borderWidth: 1,
            data: this.chartData('opens'),
            label: 'opens'
          }, {
            backgroundColor: this.chartColors('clicks'),
            borderColor: LIGHT_GRAY,
            borderWidth: 1,
            data: this.chartData('clicks'),
            label: 'clicks'
          }, this.addPaddingRing()]
        }}
        {...this.chartOptions()}
      />
    );
  }

  renderDonut() {
    return (
      <Doughnut
        data={{
          datasets: [this.addPaddingRing(), {
            backgroundColor: this.chartColors(),
            borderWidth: 0,
            data: this.chartData()
          }]
        }}
        {...this.chartOptions()}
      />
    );
  }

  render() {
    const { className } = this.props;

    const data = this.data();

    return (
      <div className={`email-chart tile-chart ${className}`}>
        {this.overview() ? this.renderOverviewDonuts() : this.renderDonut()}
        <div className="text-center email-preview-title">
          <h1 className="mb-0">
            <strong>{data.num}</strong>
          </h1>
          <h3 className="mt-0 text-muted">
            <strong>{data.label}</strong>
            <div>{data.subtitle}</div>
          </h3>
        </div>
      </div>
    );
  }
}
